import React, { PropsWithChildren } from "react";

import { clsx } from "clsx";

type Props = {
  className?: string;
};

const HelpBlock = ({ children, className, ...props }: PropsWithChildren<Props>) => (
  <span
    {...props}
    className={clsx({
      "help-block": true,
      [`${className ? className : ""}`]: className,
    })}
  >
    {children && children}
  </span>
);

export default HelpBlock;
